import { UserRole } from './authTypes';

const getRoleBasedRedirectUrl = (role: UserRole): string => {
  const redirect = {
    [UserRole.InstitutionUser]: '/orders/new',
    [UserRole.OrdersUser]: '/orders/new',
    [UserRole.ResultsUser]: '/orders',
  };
  switch (role) {
    case UserRole.InstitutionUser: {
      return redirect[UserRole.InstitutionUser];
    }
    case UserRole.OrdersUser: {
      return redirect[UserRole.OrdersUser];
    }
    case UserRole.ResultsUser: {
      return redirect[UserRole.ResultsUser];
    }
    default:
      return redirect[UserRole.InstitutionUser];
  }
};
export default getRoleBasedRedirectUrl;
